import { render, staticRenderFns } from "./slo.vue?vue&type=template&id=00cdbec6"
import script from "./slo.vue?vue&type=script&lang=js"
export * from "./slo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports